import swal from "sweetalert";
import axiosInstance from "../api";
import { GetPopUpList, setGetSingleTopUp } from "../reusable/reusableSlice";


export const getPopUpList = (data, setIsLoading) => async (dispatch) => {
    try {
        const response = await axiosInstance.post("membership/get_all", data);
        setIsLoading(false)
        if (response?.data) {
            dispatch(GetPopUpList(response?.data?.response))
        } else {
            dispatch(GetPopUpList([]))
        }
    } catch (err) {
        console.error(err);
        setIsLoading(false)
        dispatch(GetPopUpList([]))
    }
};

export const getSingleTopUpbyId = (id) => async (dispatch) => {
    try {
      const response = await axiosInstance.get(`membership/get_byid/${id}`);
      if (response?.data) {
        dispatch(setGetSingleTopUp(response?.data?.response))
      } else {
        dispatch(setGetSingleTopUp([]))
      }
    } catch (err) {
      console.error(err);
      dispatch(setGetSingleTopUp([]))
    }
  };

export const createTopUp = (data, setLoading,navigate) => async (dispatch) => {
    setLoading(true);
    try {
      const response = await axiosInstance.post("membership/create", data);
      if (response?.data?.status) {
        swal({
          text: response?.data?.response?.message,
          icon: "success",
          button: "Close",
          timer: 1500,
        });
        navigate("/topuplist")
        // return response;
      }
      else{
        swal({
          text: response?.data?.message,
          icon: "error",
          button: "Close",
          timer: 1500,
        });
      }
  
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  export const updateTopUp = (data, setLoading,navigate) => async (dispatch) => {
    setLoading(true);
    try {
      const response = await axiosInstance.post("membership/update", data);
      if (response?.data?.status) {
        swal({
          text: response?.data?.response?.message,
          icon: "success",
          button: "Close",
          timer: 1500,
        });
        navigate("/topuplist")
      }
      else{
        swal({
          text: response?.data?.message,
          icon: "error",
          button: "Close",
          timer: 1500,
        });
      }
  
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  export const deleteTopUp = (id, setIsLoading) => async (dispatch) => {
    try {
      const response = await axiosInstance.delete(`membership/delete/${id}`);
      if (response?.data?.status) {
        swal({
          text: response?.data?.response?.message,
          icon: "success",
          button: "Close",
          timer: 1500,
        });
        dispatch(getPopUpList({
          search_key: "",
          page: 1,
          parent_id:1,
        }, setIsLoading))
      }
      else{
        swal({
          text: response?.data?.message,
          icon: "error",
          button: "Close",
          timer: 1500,
        });
      }
  
    } catch (err) {
      console.error(err);
    }
  };